import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Moment from 'moment'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import Button from '@material-ui/core/Button'
import SkeletonTable from '../../../common/skeleton-table'
import Y from '../../../y18n'
import * as userActions from '../../../store/users'
import Styles from '../../../common/styles'

const mapStateToProps = state => ({
  users: state.users
})

const mapDispatchToProps = dispatch => ({
  userActions: bindActionCreators(userActions, dispatch)
})

class UserHistoryDialog extends Component {
  state = {
    page: 0,
    rowsPerPage: 25
  }

  closeFormDialog = () => {
    this.props.userActions.resetTempPassword()
  }

  render () {
    const { classes, users, userActions } = this.props
    if (!users.history) return null
    return (
      <div>
        <Dialog
          open={users.history}
          onClose={() => userActions.hideHistory()}
          classes={{
            paper: classes.wideDialogContent
          }}
        >
          <DialogTitle style={{ paddingBottom: '10px' }}>{Y`User history`}</DialogTitle>
          <DialogContent>
            <Table className={'striped'}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    {Y`Timestamp`}
                  </TableCell>
                  <TableCell>
                    {Y`Description`}
                  </TableCell>
                  <TableCell>
                    {Y`IP`}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.historyLoading
                  ? <SkeletonTable rows={this.state.rowsPerPage} cols={3} />
                  : users.active && users.active.events && users.active.events.length
                      ? users.active.events
                          .slice(
                            this.state.page * this.state.rowsPerPage,
                            this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
                          )
                          .map((event, index) => this.renderEvent(event, index))
                      : <TableRow />}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    count={users.active && users.active.events.length ? users.active.events.length : 0}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => userActions.hideHistory()}>{Y`Cancel`}</Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }

  renderEvent (event, index) {
    return (
      <TableRow key={index}>
        <TableCell>{Moment.utc(event.timestamp).local().format('YYYY-MM-DD HH:mm:ss')}</TableCell>
        <TableCell><div dangerouslySetInnerHTML={{ __html: event.description }} /></TableCell>
        <TableCell>{event.ip}</TableCell>
      </TableRow>
    )
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page })
  }

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value })
  }
}

UserHistoryDialog = connect(mapStateToProps, mapDispatchToProps)(UserHistoryDialog)
export default withStyles(Styles)(UserHistoryDialog)



// WEBPACK FOOTER //
// ./src/pages/users/containers/user-history-dialog.js